import { CircularProgress, Container } from '@mui/material'
import { ThemeProvider as ThemeProviderV5 } from '@mui/material/styles'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getFilteredCourses } from '../../../../../redux/actions/courses'
import { IRootState } from '../../../../../redux/types'
import useScreenWidthView from '../../../../shared/hooks/useScreenWidth'
import { adminThemeV5 } from '../../../../shared/styles/themes/AdminTheme'
import CoursesNotifications from '../components/CoursesNotifications'
import DraggableCourseGrid from '../components/DraggableCourseGrid'

type OptionsType = { [key: string]: number }

interface IFilter {
  family_id: number | null
  brand_id: number | null
  line_id: number | null
  language_id: number | null
  coursetype_id: number | null
  countries: number[]
  filterBy?: OptionsType
  orderby_id?: number | null
}

const ManagementCourses = () => {
  const dispatch = useDispatch()
  const isMobile = useScreenWidthView(750)
  const isTablet = useScreenWidthView(1000)
  const { courses, loading } = useSelector((state: IRootState) => state.course)
  const { globalFamilyId, globalBrandId, globalLineId, globalCountriesId, globalLanguageId } = useSelector(
    (state: IRootState) => state.global
  )

  const [filters, setFilters] = useState<IFilter>({
    family_id: null,
    brand_id: null,
    line_id: null,
    language_id: null,
    coursetype_id: null,
    countries: [],
    orderby_id: 1
  })

  useEffect(() => {
    setFilters({
      ...filters,
      family_id: globalFamilyId,
      brand_id: globalBrandId,
      line_id: globalLineId,
      language_id: globalLanguageId,
      coursetype_id: null,
      countries: globalCountriesId
    })
  }, [globalFamilyId, globalBrandId, globalLineId, globalLanguageId, globalCountriesId])

  useEffect(() => {
    dispatch(getFilteredCourses(filters))
  }, [dispatch])

  return (
    <>
      {loading && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '150px'
          }}
        >
          <CircularProgress size={48} sx={{ color: '#1976d2' }} />
          <span style={{ marginLeft: 16, color: '#1976d2', fontWeight: 500, fontSize: 18 }}>Cargando cursos...</span>
        </div>
      )}
      <ThemeProviderV5 theme={adminThemeV5}>
        <Container maxWidth="xl">
          <DraggableCourseGrid courses={courses} isMobile={isMobile} isTablet={isTablet} />
        </Container>
      </ThemeProviderV5>
      <CoursesNotifications />
    </>
  )
}

export default ManagementCourses
